import React from 'react';
import { string, func } from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';
import { ProjectShoppingHeader } from '../ProjectShoppingHeader/ProjectShoppingHeader';
import { PS_CONTENT } from '../../../constants';
import { EntryCardPlaceholder } from './EntryCardPlaceholder';
import { track } from '../../../Analytics';

const PSEntryCard = ({
  setIsEntryDrawerOpen,
  projectName,
  channel,
  bannerUrl,
  setIsPSRendered
}) => {
  if (!projectName && !bannerUrl) {
    return <EntryCardPlaceholder />;
  }

  const headerText = projectName;
  const imageUrl = bannerUrl;

  const onClick = () => {
    track('get-started-click');
    setIsEntryDrawerOpen(true);
    setIsPSRendered(true);
  };

  return (
    <div className="sui-grid sui-grid-cols-12 sui-gap-4">
      <div className="sui-col-span-4 md:sui-col-span-3">
        <img
          src={imageUrl}
          alt="PS Entry Card"
          title="Banner Image"
          loading="lazy"
          // eslint-disable-next-line tailwindcss/no-arbitrary-value
          className="sui-aspect-square sui-object-cover sui-w-full sui-max-w-[210px]"
          width={210}
          height={210}
        />
      </div>
      <div className="sui-flex sui-flex-col sui-justify-between sui-col-span-8 md:sui-col-span-9">
        <ProjectShoppingHeader
          channel={channel}
          content={PS_CONTENT}
          isEntryPoint
          title={headerText}
        />
        <Button fullWidth={false} onClick={onClick} variant="secondary">Get Started</Button>
      </div>
    </div>
  );
};

export { PSEntryCard };

PSEntryCard.propTypes = {
  setIsEntryDrawerOpen: func,
  projectName: string,
  bannerUrl: string,
  channel: string,
  setIsPSRendered: func.isRequired
};
PSEntryCard.defaultProps = {
  setIsEntryDrawerOpen: false,
  projectName: '',
  bannerUrl: '',
  channel: 'desktop'
};
